module.exports = __webpack_public_path__ + "img/vietnam.3e1e196e.svg";